<template>
  <div class="flex flex-col gap-4">
    <div class="flex flex-row items-center">
      <Icon iconClass="fas fa-building inline text-blue-200 mr-8" />
      <Body class="inline">{{ clinic }}</Body>
    </div>
    <div class="flex flex-row items-center">
      <Icon iconClass="fas fa-map-marker-alt inline text-blue-200 mr-8" />
      <Body class="inline">{{ address }}</Body>
    </div>
    <div class="flex flex-row items-center">
      <Icon iconClass="fas fa-phone-alt inline text-blue-200 mr-8" />
      <Body class="inline">{{ formattedPhone }}</Body>
    </div>
  </div>
</template>

<script>
import Icon from '~/components/common/Icon.vue'
import Body from '~/components/common/Typography/Body.vue'

export default {
  components: { Icon, Body },
  props: {
    clinic: {
      type: String,
      default: 'N/A',
    },
    address: {
      type: String,
      required: true,
    },
    phone: {
      type: String,
      default: 'N/A',
    },
  },
  computed: {
    formattedPhone() {
      return this.phone === 'N/A'
        ? this.phone
        : this.phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
    },
  },
}
</script>
